/* eslint-disable react-hooks/rules-of-hooks */
import { lazy, Suspense } from 'react';
import { AuthGuard, RoleGuard } from '@emfood/shared';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import { ROLES } from 'src/api/roles-config';
import DashboardLayout from 'src/layouts/dashboard';

import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { SurplusListSearchParamsSchema } from 'src/sections/surplus/surplus-list/search-params';

import { paths } from '../paths';
import { rootRoute } from './root';

const AddSurplusListing = lazy(() => import('src/sections/surplus/add-surplus/view'));
const EditSurplusListing = lazy(() => import('src/sections/surplus/edit-surplus/view'));
const SurplusList = lazy(() => import('src/sections/surplus/surplus-list/view'));

// Surplus routes
const surplusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'surplus',
  component: () => (
    <AuthGuard
      splashScreen={<SplashScreen />}
      loginPath={paths.auth.jwt.login}
      pathOnAuthProblem={paths.auth.jwt.login}
    >
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AuthGuard>
  ),
});

const surplusIndexRoute = createRoute({
  getParentRoute: () => surplusRoute,
  path: '/',
  validateSearch: (search: unknown & SearchSchemaInput) =>
    SurplusListSearchParamsSchema.validateSync(search),
  component: () => (
    <RoleGuard requiredRoles={[ROLES.ADMIN, ROLES.DISTRIBUTOR_ADMIN, ROLES.DATA_MANAGER]}>
      <SurplusList />
    </RoleGuard>
  ),
});

const surplusAddRoute = createRoute({
  getParentRoute: () => surplusRoute,
  path: '/add/$distributorOrgId/$distributorSiteId',
  component: AddSurplusListing,
});

const surplusEditRoute = createRoute({
  getParentRoute: () => surplusRoute,
  path: '/edit/$distributorOrgId/$distributorSiteId/$surplusEntityId',
  component: EditSurplusListing,
});

export const surplusRouteTree = surplusRoute.addChildren([
  surplusIndexRoute,
  surplusAddRoute,
  surplusEditRoute,
]);
